module.exports = __webpack_public_path__ + "media/purpose/purpose@3x-1df8de7f.png";